import i18n from "i18next";
import LanguageDetector from "i18next-browser-languagedetector";

import { messages } from "./languages";

i18n.use(LanguageDetector).init({
	debug: false,
	defaultNS: ["translations"],
	fallbackLng: "pt",
	ns: ["translations"],
	resources: messages,
});

// i18next 19 não faz bind de `t`: passado solto (`fn(i18n.t)`) o `this` some e
// explode em `this.translator`. Use este `t` quando precisar de um callback.
const t = (key, opts) => i18n.t(key, opts);

export { i18n, t };
